import { render } from "./NoticeTable.vue?vue&type=template&id=e5ed3f5a&scoped=true"
import script from "./NoticeTable.vue?vue&type=script&lang=js"
export * from "./NoticeTable.vue?vue&type=script&lang=js"

import "./NoticeTable.vue?vue&type=style&index=0&id=e5ed3f5a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ed3f5a"]])

export default __exports__